import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        coral: "bg-coral text-primary-foreground hover:-translate-y-0.5 transition-all",
        destructive: "bg-[#b53332] text-white hover:bg-[#b53332]/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-[#f1edea] text-black border border-[#d2cac0] hover:bg-dark-beige hover:text-[#141413] hover:-translate-y-0.5 transition-all",
        "dark-beige-secondary":
          "bg-dark-beige text-black border border-[#e1ddd6]  hover:bg-stone-100 hover:border-input hover:border  hover:text-black hover:-translate-y-0.5 transition-all",

        "light-beige-secondary":
          "bg-beige text-black border border-[#e1ddd6] hover:bg-dark-beige hover:text-black hover:border-white hover:-translate-y-0.5 transition-all",
        "second-white":
          "bg-white border border-gray-400 rounded-md px-3 py-1.5 text-black font-medium hover:bg-stone-100 hover:border-stone-400 transition-all cursor-pointer",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        empty: "",
      },
      size: {
        xs: "h-6 px-2 py-1",
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
